import React from 'react';

const Settings = () => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
      </div>

      <div className="card">
        <div className="card-body">
          <p className="text-gray-600 text-center py-8">
            Settings management will be implemented here.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Settings;